import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteProductByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteProductByIdMutation = { __typename?: 'mutation_root', delete_products_by_pk?: { __typename?: 'products', id: any } | null };


export const DeleteProductByIdDocument = gql`
    mutation deleteProductById($id: uuid!) {
  delete_products_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteProductByIdMutationFn = Apollo.MutationFunction<DeleteProductByIdMutation, DeleteProductByIdMutationVariables>;

/**
 * __useDeleteProductByIdMutation__
 *
 * To run a mutation, you first call `useDeleteProductByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductByIdMutation, { data, loading, error }] = useDeleteProductByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductByIdMutation, DeleteProductByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductByIdMutation, DeleteProductByIdMutationVariables>(DeleteProductByIdDocument, options);
      }
export type DeleteProductByIdMutationHookResult = ReturnType<typeof useDeleteProductByIdMutation>;
export type DeleteProductByIdMutationResult = Apollo.MutationResult<DeleteProductByIdMutation>;
export type DeleteProductByIdMutationOptions = Apollo.BaseMutationOptions<DeleteProductByIdMutation, DeleteProductByIdMutationVariables>;